// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TSuggestVillagesTariffProRequest,
  TSuggestVillagesTariffProModel,
  IMappers,
  TSuggestVillagesTariffProResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IVillageListForTariffProResponseSchema } from '../../entities/entities/VillageListForTariffProResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createSuggestVillagesTariffProModel(
  parameters: TSuggestVillagesTariffProRequest,
): TSuggestVillagesTariffProModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'countryside-search',
    pathApi: '/v1/suggest-villages-tariff-pro/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ISuggestVillagesTariffProOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TSuggestVillagesTariffProRequest;
}

export async function fetchSuggestVillagesTariffPro<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISuggestVillagesTariffProOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TSuggestVillagesTariffProResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSuggestVillagesTariffProModel(parameters),
    config,
  )) as FetchResponse<TSuggestVillagesTariffProResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IVillageListForTariffProResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TSuggestVillagesTariffProResponse>;
}
